import React from 'react';
import { bool } from 'prop-types';

import NumberRangeFilterPlain from './NumberRangeFilterPlain';
import NumberRangeFilterPopup from './NumberRangeFilterPopup';

const NumberRangeFilter = props => {
  const { showAsPopup, ...rest } = props;
  return showAsPopup ? <NumberRangeFilterPopup {...rest} /> : <NumberRangeFilterPlain {...rest} />;
};

NumberRangeFilter.defaultProps = {
  showAsPopup: false,
};

NumberRangeFilter.propTypes = {
  showAsPopup: bool,
};

export default NumberRangeFilter;
